import { Box, Stack, Typography } from '@mui/material'
import SearchRow from '@/components/SecondaryLeftNavigation/components/SearchRow'
import { SettingsSectionNavList } from '@/components/SecondaryLeftNavigation/components/SettingsSectionNavList'
import { useSettingsSectionFilter } from '@/components/SecondaryLeftNavigation/components/useSettingsSectionFilter'
import sectionStyles from '@/components/SecondaryLeftNavigation/components/SettingsSection.module.scss'

/**
 * @param {{
 *   activeSectionId: string,
 *   onSectionSelect: (sectionId: string) => void,
 * }} props
 */
export default function SettingsSectionSidebar({ activeSectionId, onSectionSelect }) {
  const { searchValue, setSearchValue, filteredGroups } = useSettingsSectionFilter()

  return (
    <Stack className={sectionStyles.stack} direction="column" spacing={0}>
      <SearchRow
        value={searchValue}
        onChange={setSearchValue}
        placeholder="Search settings"
      />
      <Box className={sectionStyles.listSplit} component="nav" aria-label="Settings">
        {filteredGroups.length === 0 ? (
          <Typography variant="body2" sx={{ px: 1.25, py: 0.75, color: 'text.secondary', fontSize: 13 }}>
            No matching settings.
          </Typography>
        ) : (
          <SettingsSectionNavList
            filteredGroups={filteredGroups}
            activeSectionId={activeSectionId}
            onSectionSelect={onSectionSelect}
          />
        )}
      </Box>
    </Stack>
  )
}
